import classNames from "classnames";
import { Dot } from "../Icon/Icon";
import styles from "./Badge.module.scss";

type BadgeSize = "small" | "medium" | "large" | "xlarge";
type BadgeVariant = "pill" | "badge";
export type BadgeColor =
  | "default"
  | "outline"
  | "info"
  | "success"
  | "purple"
  | "indigo"
  | "primary"
  | "warning"
  | "error";

interface BadgeProps {
  children?: React.ReactNode;
  color?: BadgeColor;
  size?: BadgeSize;
  variant?: BadgeVariant;
  showDot?: boolean;
  loading?: boolean;
  className?: string;
}

function Badge({
  children,
  showDot = true,
  color = "default",
  size = "small",
  variant = "pill",
  loading,
  className,
}: BadgeProps) {
  return (
    <div
      className={classNames(
        styles.container,
        styles[color],
        styles[size],
        styles[variant],
        className,
      )}
    >
      {!!showDot && !loading && <Dot className={styles.icon} size="xxsmall" />}
      {!!loading && (
        <div className={classNames(styles.icon, styles.loadingIcon)}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
      {children && <span className={styles.text}>{children}</span>}
    </div>
  );
}

export default Badge;
